module["exports"] = [
	"پاپ",
	"فلک",
	"دنیایٰ",
	"جاز",
	"فنک",
	"کلاسکی",
	"لاطینی",
	"پرانی",
	"ریپ",
];
